import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
  <div>
    <h3>Boulevard</h3>

    <address>
      <a href="https://www.google.fi/maps/place/Bulevardi+6,+00120+Helsinki/" rel="noopener noreferrer">Bulevardi 6</a><br />
      00120 Helsinki
    </address>

    <a href="mailto:info@boulevard.fi">info@boulevard.fi</a>
    <a href="tel:+358103229387">{intl.locale==='en'?'+358 ':'0'}10 322 9387</a>

    <a href="https://www.facebook.com/boulevardhelsinki/" className="some facebook">Facebook</a>
    <a href="https://www.instagram.com/boulevardhelsinki/" className="some instagram">Instagram</a>
  </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js